import React, { useState, useEffect, useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

// apis
import { fetchSalesPayment } from '@/apis/aipass'

// components
import { SettingSalesManagerTab } from '@/components/organisms/settings/sales-manager/tab'
import { SettingPaymentList } from '@/components/organisms/settings/sales-manager/payment/list'
import { SettingsLayout } from '@/components/layouts/settings-layout'
import { TabContainer } from '@/components/organisms/settings/tab-container'
import { Button } from '@/components/atoms'
import { ButtonType } from '@/components/atoms/button'
import { AccountContext } from '@/contexts/account'
import { isScreenReadOnlyForUi } from '@/libs/hotel-pms-permission'

type ContainerProps = {}

export const SettingSalesManagerPayment: React.FC<ContainerProps> = () => {
  const { t } = useTranslation()
  const { permissions, permissionsLoaded, permissionsError } = useContext<any>(AccountContext)
  const isSettingsReadOnly = isScreenReadOnlyForUi(permissions, 'settings', permissionsLoaded, permissionsError)

  const [paymentSettings, setPaymentSettings] = useState<any>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const history = useHistory()
  const location = useLocation()

  const _fetchSalesPayment = async () => {
    setIsLoading(true)
    await fetchSalesPayment()
      .then(res => {
        if (!res?.salesPayment) {
          console.warn('salesPayment is empty')

          setPaymentSettings([])
          return
        }

        setPaymentSettings(res?.salesPayment)
      })
      .catch(() => {
        console.log(t('Communication failed'))
      })
    setIsLoading(false)
  }

  useEffect(() => {
    _fetchSalesPayment()
  }, [])

  return (
    <SettingsLayout loading={isLoading}>
      <TabContainer tabComponent={<SettingSalesManagerTab currentTab="Payment" />}>
        <div css={settingListContainerStyle}>
          <div css={editButtonWrapperStyle}>
            <Button
              buttonType={isSettingsReadOnly ? ButtonType.PrimaryDisabled : ButtonType.Secondary}
              isDisabled={isSettingsReadOnly}
              onClick={() => {
                if (isSettingsReadOnly) {
                  alert(t('HotelPms.Error.readOnly'))
                  return
                }
                history.push({ pathname: '/setting/sales-manager/payment/edit', search: location.search })
              }}
              width={75}
              height={32}
              fontSize={12}
            >
              {t('Edit')}
            </Button>
          </div>
          <SettingPaymentList paymentSettings={paymentSettings} />
        </div>
      </TabContainer>
    </SettingsLayout>
  )
}

const settingListContainerStyle = css({
  boxShadow: '0px 0px 6px #0000001A',
  borderRadius: '0 5px 5px 5px',
  background: '#FFF',
  position: 'relative',
  height: 'calc(100% - 45px)',
})

const editButtonWrapperStyle = css({
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '24px 32px 34px',
})
